import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the loginPage state domain
 */

const selectGlobalPageDomain = state => state.global || initialState;
const selectOnboardDeviceSubstore = state => state.global?.deviceOnboard || initialState.deviceOnboard

/**
 * Other specific selectors
 */

export const isLoggedInSelector = createSelector(selectGlobalPageDomain, globalState => globalState.isLoggedIn);
export const getUserSelector = createSelector(selectGlobalPageDomain, globalState => globalState.user);

export const validateTokenLoaderSelector = createSelector(
  selectGlobalPageDomain,
  globalState => globalState.tokenLoader,
);
export const tokenSelector = createSelector(selectGlobalPageDomain, globalState => globalState.token);
export const menuItemsSelector = createSelector(selectGlobalPageDomain, globalState => globalState.menuItems);
export const getLinearProgressStatus = createSelector(
  selectGlobalPageDomain,
  globalState => globalState.showLinearLoader,
);
export const getCircularProgressStatus = createSelector(
  selectGlobalPageDomain,
  globalState => globalState.showCircularLoader,
);

export const getErrorObjectSelector = createSelector(selectGlobalPageDomain, globalState => globalState.errorObj);
export const getRolesSelector = createSelector(selectGlobalPageDomain, globalState => globalState.roles);

export const getSettingsSelector = createSelector(
  selectGlobalPageDomain,
  globalState => globalState.settings || initialState.settings,
);
export const notificationSoundSettingSelector = createSelector(
  getSettingsSelector,
  settings => settings.notificationSound,
);

export const getOnboardDeviceDeviceIdSelector = createSelector(selectOnboardDeviceSubstore, deviceOnboard => deviceOnboard.deviceId || initialState.deviceOnboard.deviceId)
export const getOnboardDeviceSupervisroIddSelector = createSelector(selectOnboardDeviceSubstore, deviceOnboard => deviceOnboard.supervisorId || initialState.deviceOnboard.supervisorId)
export const getOnboardDeviceValidResponseSelector = createSelector(selectOnboardDeviceSubstore, deviceOnboard => deviceOnboard.validDeviceResponse || initialState.deviceOnboard.validDeviceResponse)
